import { render, staticRenderFns } from "./Photographer.vue?vue&type=template&id=071d5fe1&scoped=true&"
import script from "./Photographer.vue?vue&type=script&lang=js&"
export * from "./Photographer.vue?vue&type=script&lang=js&"
import style0 from "./Photographer.vue?vue&type=style&index=0&id=071d5fe1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071d5fe1",
  null
  
)

export default component.exports